import { render, staticRenderFns } from "./ProcessList.vue?vue&type=template&id=3980dd78&scoped=true"
import script from "./ProcessList.vue?vue&type=script&lang=js"
export * from "./ProcessList.vue?vue&type=script&lang=js"
import style0 from "./ProcessList.vue?vue&type=style&index=0&id=3980dd78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980dd78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3980dd78')) {
      api.createRecord('3980dd78', component.options)
    } else {
      api.reload('3980dd78', component.options)
    }
    module.hot.accept("./ProcessList.vue?vue&type=template&id=3980dd78&scoped=true", function () {
      api.rerender('3980dd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/ProcessList.vue"
export default component.exports